interface AlertBadgeProps {
  count: number
}

const AlertBadge: React.FC<AlertBadgeProps> = ({count} : AlertBadgeProps) => {
  return<>{ count > 0 && (
    <span
      style={{
        background: "red",
        color: "white",
        borderRadius: "12px",
        padding: "2px 8px",
        marginLeft: "10px",
        marginRight: "10px",
        fontSize: "0.8rem",
        fontWeight: "bold",
      }}
    >
      {count}
    </span>
  )}</>
}

export default AlertBadge;